import { cn } from "@/lib/utils";

import isotipo from "./isotipo.png";
import isotipoBlanco from "./isotipo-blanco.png";

/**
 * Isotipo oficial de Nevora (internal/marketing/brand): el isotipo 2D canónico
 * (`nevora-isotipo-2d-transparente.png`, 512×337) y su versión en blanco (la copia oficial
 * `logo-tight-white.png`, 1058×725). Solo se fija la ALTURA (`className="h-7"`): la anchura
 * sale de las proporciones de cada fichero, así el logo nunca se estira ni se aplasta
 * (corrección de Robert, 01/10/2026: se pintaba en una caja cuadrada).
 *
 * `tono="auto"` cambia al isotipo blanco en modo oscuro; `tono="blanco"` es para fondos
 * siempre oscuros (panel de marca del login).
 */
export const Isotipo = ({
  className,
  tono = "auto",
}: {
  className?: string;
  tono?: "auto" | "blanco";
}) => {
  const base = "w-auto max-w-none shrink-0 object-contain";
  if (tono === "blanco") {
    return <img src={isotipoBlanco} alt="" className={cn(base, className)} />;
  }
  return (
    <>
      <img
        src={isotipo}
        alt=""
        className={cn(base, "dark:hidden", className)}
      />
      <img
        src={isotipoBlanco}
        alt=""
        className={cn(base, "hidden dark:block", className)}
      />
    </>
  );
};
